import React from 'react';
import { UserProfile } from '../Profile';
import ContactInfoCard from './ContactInfoCard';
import PreferencesCard from './PreferencesCard';
import RecentActivityCard from './RecentActivityCard';
import { TUserSelfPayload } from '@/data/types';

interface ProfileContentProps {
  userProfile: UserProfile;
  updateProfile: (data: Partial<TUserSelfPayload>) => Promise<void>;
}

const ProfileContent: React.FC<ProfileContentProps> = ({ userProfile, updateProfile }) => {
  return (
    <div className="py-8">
      {/* Main Content Grid */}
      <div className="grid grid-cols-1 gap-8 lg:grid-cols-2">
        <ContactInfoCard userProfile={userProfile} updateProfile={updateProfile} />
        <PreferencesCard />
      </div>

      {/* Full Width Components */}
      <div className="mt-8">
        <RecentActivityCard />
      </div>
    </div>
  );
};

export default ProfileContent;
